import logdown from 'logdown';
import * as React from 'react';
import { connect } from 'react-redux';
import { returntypeof } from 'react-redux-typescript';
import { Route, Switch, RouteProps } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';

import { State } from '../../reducers';
import { DataSources } from '../datasources';
import { Home } from '../home';
import { Navbar, routesList, Sidebar, setActiveRoute, toggleSideBarIsOpen } from '../navigation';
import { Reports } from '../reports';
import { Templates } from '../templates';
import { Profile } from '../user';

const pages: { [param: string]: any } = {
  Home,
  Profile,
  DataSources,
  Templates,
  Reports,
};

const logger = logdown('component:Dashboard');

class Component extends React.Component<Props, {}> {
  protected updateNavigation() {
    const pathName = this.props.location?.pathname;
    const route = routesList.find((route) => `${route.layout}${route.path}` === pathName);
    if (route) {
      this.props.setActiveRoute(route.name);
      this.props.toggleSideBarIsOpen(false);
    }
  }
  componentDidMount() {
    logger.log(`Component did mount ${JSON.stringify(this.props.location)}`);

    this.updateNavigation();
  }

  componentDidUpdate(prevProps: Props) {
    logger.log(`Component did update ${JSON.stringify(prevProps.location)} ${JSON.stringify(this.props.location)}`);

    const isPathChanged = prevProps.location !== this.props.location;

    logger.log(`Path changed: ${isPathChanged}`);
    if (isPathChanged) {
      this.updateNavigation();
    }
  }

  public render() {
    return (
      <div className={this.props.sideBar.isOpen ? 'nav-open' : ''}>
        <Sidebar />
        <div className="main-panel">
          <Navbar {...this.props} />
          <Switch>
            {routesList
              .filter((route) => this.props.user.profile.role.exists((role) => route.allowedForRoles.includes(role)))
              .map((r) => (
                <Route key={r.name} exact={true} path={r.layout + r.path} component={pages[r.componentName]} />
              ))}
          </Switch>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>) =>
  bindActionCreators(
    {
      setActiveRoute,
      toggleSideBarIsOpen,
    },
    dispatch,
  );

const mapStateToProps = (state: State) => ({
  user: state.user,
  sideBar: state.sideBar,
});

const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & typeof dispatchProps & RouteProps;

// @ts-ignore
export default connect<typeof stateProps, typeof dispatchProps, any>(mapStateToProps, mapDispatchToProps)(Component);
